import React, { useMemo } from "react";
import css from "./.module.scss";
import { FiltersUi } from "./controls";
import { generateUrl, usePath } from "@/src/contexts/path/path";
import AppLink from "@/components/new-resolver/app.ink";

export const QuickFilters = ({ showMore }) => {
  const {
    updateContext,
    filters: { published, ...filters } = {},
    quickFields = [],
    category,
  } = usePath();

  const Fields = useMemo(() => {
    const fls = quickFields.flat(1).filter((f) => f.type !== "checkbox");
    if (!showMore)
      return (
        quickFields[0]
          ?.filter((f) => f.type !== "checkbox")
          ?.map((field) => [FiltersUi[field.type], field]) || []
      );
    return fls.map((field) => [FiltersUi[field.type], field]) || [];
  }, [category, quickFields, showMore]);

  const SwitchFields = useMemo(() => {
    if (!showMore) return [];
    const fls = quickFields.flat(1).filter((f) => f.type === "checkbox");
    return fls.map((field) => [FiltersUi[field.type], field]) || [];
  }, [category, quickFields, showMore]);

  return (
    <div className={css.filters}>
      {Fields.map(([Component, props]) => (
        <Component
          key={props.name}
          {...props}
          value={
            filters?.[props?.name]?.[props?.operation] === undefined
              ? filters?.[props?.name]
              : filters?.[props?.name]?.[props?.operation]
          }
          onChange={(name, filter, filterAsPath) => {
            updateContext({
              filters: { ...filters, [name]: filter },
              listing: null,
              page: 0,
              filterAsPath,
            });
          }}
        />
      ))}
      {!!SwitchFields.length && (
        <div className={css.switch}>
          <p>أخرى</p>
          <div className={css.horizontalList}>
            {SwitchFields.map(([Component, props]) => (
              <Component
                key={props.name}
                {...props}
                value={
                  filters?.[props?.name]?.[props?.operation] ||
                  filters?.[props?.name]
                }
                onChange={(name, filter) => {
                  updateContext({
                    filters: { ...filters, [name]: filter },
                    listing: null,
                    page: 0,
                  });
                }}
              />
            ))}
          </div>
        </div>
      )}
    </div>
  );
};
export const AllQuickFiltersAsLinks = () => {
  const pathData = usePath();
  const {
    filters: { published, ...filters } = {},
    quickFields = [],
    category,
    district,
    direction,
    listing,
    city,
  } = pathData;
  const url = useMemo(
    () => generateUrl({ category, district, direction, city })?.split("?")[0],
    [category, district, direction, city],
  );

  const Fields = useMemo(() => {
    return (
      (quickFields || [])
        .flat(1)
        .map((field) =>
          field.options
            ? field.options.map((x) => ({ ...field, ...x }))
            : field,
        )
        .flat(1)
        .filter((f) => f.path) || []
    );
  }, [category, quickFields]);

  return (
    <div className={listing ? "white" : ""}>
      <div className={css.links + (listing ? " " + css.listing : "")}>
        {Fields.map((f) => (
          <AppLink
            key={f.path}
            onClick={() => {
              scrollTo(0, 0);
              if (f.name === "prices") {
                return pathData.updateContext({
                  filters: {
                    [f.value]: {
                      gte: 1,
                    },
                    rent_period: { eq: 3 },
                  },
                  listing: null,
                  page: 0,
                  filterAsPath: f.path,
                });
              }

              if (typeof f.value === "object") {
                return pathData.updateContext({
                  filters: {
                    [f.name]: f.value,
                  },
                  listing: null,
                  page: 0,
                  filterAsPath: f.path,
                });
              }
              pathData.updateContext({
                filters: {
                  [f.name]: {
                    [f.operation]: f.value,
                  },
                },
                listing: null,
                page: 0,
                filterAsPath: f.path,
              });
            }}
            path={(url + f.path).replaceAll("//", "/")}
          >
            <span>#</span>
            {f.label?.ar}
          </AppLink>
        ))}
      </div>
    </div>
  );
};

export default QuickFilters;
